<template>
  <div class="text-center py-12">
    <div class="inline-flex items-center space-x-2 text-gray-500">
      <component :is="icon" class="w-5 h-5 animate-spin" />
      <span>{{ message || '正在加载...' }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  icon: Component
  message?: string
}>()
</script>

<style scoped></style>
